export default {
    clipboard: {
        copy_failed: '复制失败，请重试',
        no_content: '暂无可复制的内容',
    },
    // 临时订单
    ptzhanghao: {
        bqgl: '标签管理',
        bqgl1: '生成订单',
        bqgl2: '平台',
        bqgl3: '国家',
        bqgl4: '店铺',
        bqgl5: '订单号',
        bqgl6: '收件地址',
        bqgl7: '下单时间',
        bqgl8: '拉取时间',
        bqgl9: 'SKU图片',
        bqgl10: '产品名称',
        bqgl11: '转入时间',
        ls1: '状态',
        ls2: '临时订单',
        ls3: '已取消',
        ls4: '取消订单',
        a0: '全部',
        a1: '临时订单',
        a2: '已转入订单',
        a3: 'shopify',
        b3: '操作',
    },
    // 首页翻译
    home: {
        gglb1: '公告列表',
        gglb2: '标题',
        gglb3: '发布时间',
        gglb4: 'SKU预警',
        gglb5: '库存管理',
        gglb6: '订单统计',
        gglb7: '开始日期',
        gglb8: '结束日期',
        gglb9: '今日',
        gglb10: '昨日',
        gglb11: '近7日',
        gglb12: '近30日',
        gglb13: '全部',
        gglb14: '财务信息',
        gglb15: '可用额度=余额',
        gglb16: '授信',
        gglb17: '临额',
        gglb18: '冻结',
        gglb19: '工单统计',
        gglb20: '最新公告',
        gglb21: '更多...',
        gglb22: '工单待回复',
        gglb23: '等待回复',
    },
    // 菜单翻译
    setyj: {
        kongzhitai: '控制台',
        guoneifahuo: '国内大货',
        zxxb: '专线小包',
        kuaididingdan: '快递打单',
        haiwaifahuo: '海外发货',
        caiwuzhongxin: '财务中心',
        syssettings: '系统设置',
        ptdr: '平台管理',

    },
    //二级翻译
    seterj: {
        gnlist: '订单列表',
        dropshippingOrder: '代发订单',
        transferOrder: '中转订单',
        gnwaybill: '预报订单',
        gnpilsc: '批量上传',
        ddlist: '订单列表',
        zlist: '订单列表',
        zwaybill: '预报订单',
        zpilsc: '批量上传',
        rcdgl: '入仓总单',
        waybill: '创建运单',
        pilsc: '批量上传',
        hwddlist: '订单列表',
        hwybdd: '预报订单',
        hwplsc: '批量上传',
        xjrk: 'SKU库存',
        xjrk_zx: '整箱库存',
        rkjl: 'SKU入库',
        caiwuls: '财务流水',
        dhzd: '大货账单',
        ddgl: '地址管理',
        qdjg: '渠道价格',
        gdlb: '工单列表',
        xtpz: '系统配置',
        ptgl: '平台管理',
        xbzd: '小包账单',
        dscz: '仓租提醒',
        skugl: 'SKU管理',
        xstj: '销售统计',
        ddxg: '打单相关',
        ptzh: '平台账号',
        skugx: 'SKU关系',
        zcmd: '自传面单',
        hwsf: 'SCANFORM',
        kdsf: 'SCANFORM',
        lsddlb: '临时订单列表',
        platform_shops: '店铺列表',
        platform_orders: '平台订单',
        kcdc: '库存调仓',
        rkjl_zx: '整箱入库',
    },
    // 快递打单-预报订单
    kdyddd: {
        sj_name: '收件姓名',
        sj_tel: '收件电话',
        sj_gs: '收件公司',
        sj_dizhi: '收件地址',
        sj_ycdizhi: '延长地址',
        sj_chengshi: '收件城市',
        sj_zouseng: '收件州省',
        sj_youbian: '收件邮编',
        sj_gj: '目的国家',
        dd_bh: '订单编号',
        sj_zdybz: '自定备注',
        insurance: '投保金额',
        sjxinxi: '收件信息',
        orderSIZE: '订单设置',
        xzsl: '箱子数量',
        unitsize: '单位设置',
        xts: '小提示：',
        xtswenzi: '可以在Excel中编辑好，复制并粘贴到下方表格。',
    },
    // 快递打单-预报订单placeholder
    placeholder: {
        sj_name: '请输入收件姓名',
        sj_tel: '请输入收件电话',
        sj_gs: '请输入收件公司',
        sj_dizhi: '请输入收件地址',
        sj_ycdizhi: '地址过长时使用',
        sj_chengshi: '请输入收件城市',
        sj_zouseng: '请输入收件州省',
        sj_youbian: '请输入收件邮编',
        sj_gj: '请选择国家',
        dd_bh: '为空时自动生成',
        sj_zdybz: '多用于Label上的备注',
        insurance: '为空不投保 (需渠道支持)',
        dizhiku: '保存到收件地址库',
        fbayundan: 'FBA运单',
        xtzlcc: '相同重量尺寸',

    },
    // 快递打单-批量上传
    kdpilsc: {
        pilisngTips: '单票单件按箱数上传，一票多件按箱号上传。',
        mobanTips: '模板',
        xzplmbTips: '下载批量模板',
        ddpcTips: '订单批次：',
        zlszTips: '重量设置：',
        scwjTips: '上传文件：',
        ddnumTips: '订单数量：',
        sclistTips: '上传列表',
        xitlistTips: '( 注意:系统仅保留30天的Excel导入记录! )',
        piliangTips: '批量删除',
        pichiTips: '批次',
        fileTips: '文件',
        ordernumTips: '订单数量',
        successnumTips: '成功数量',
        failnumTips: '失败数量',
        uptime1Tips: '上传时间',
        caozuoTips: '操作',
        Download_Batch_Template: '下载批量模板_箱号版',//下载批量模板_箱号版

    },
    // 快递打单-订单列表
    kdlist: {
        gjz: '关键字',
        gjzpay: '请输入关键字(订单号/收件人/跟踪号/批量上传批次)',
        pi: '批',
        ysfs: '运输方式',
        ysfspay: '请选择运输方式',
        zlfw: '重量范围',
        zlfwpay: '请输入重量范围(kg)',
        fjdz: '发件地址',
        fjdzpay: '请输入发件地址ID',
        xuan: '选',
        cxfs: '查询方式',
        cxfspay: '请选择批量查询方式',
        dorpay: '订单号或跟踪号批量查询，每行一个(该查询只支持精确查询，不支持模糊查询)',
        kdcx: '快递查询',
        all: '全部',
        ydy: '已打印',
        wdy: '未打印',
        sbdd: '失败订单',
        wtk: '无退款',
        ddk: '待退款',
        ytk: '已退款',
        bntk: '不能退款',
        djz: '冻结中',
        rifw: '日期范围',
        ksrq: '开始日期',
        jsrq: '结束日期',
        jr: '今日',
        zr: '昨日',
        jqr: '近7日',
        jssr: '近30日',
        hcdspt: '回传电商平台',
        ysxc: '已筛选出',
        tddxx: '条订单信息',
        sx: '筛选',
        cz: '重置',
        hc0: '待回传',
        hc1: '回传中',
        hc2: '回传成功',
        hc3: '回传失败',
        cx1: '暂未查询',
        cx2: '等待揽收',
        cx3: '运输途中',
        cx4: '到达待取',
        cx5: '投递失败',
        cx6: '可能异常',
        cx7: '签收成功',
        ssjg: '试算价格',
        sckdd: '生成快递单',
        dyxtbq: '打印系统标签',
        dyxtbq1: 'ZPl打印面单',
        tswlpt: '推送物流平台',
        zzt: '子状态',
        mdxz: '面单下载',
        mdxz1: '合并下载',
        mdxz2: ' 打包下载（按订单号）',
        mdxz3: '打包下载（按跟踪号）',
        mdxz4: '打包下载（按运单号）',
        mdxz5: '打包下载（订单号@跟踪号）',
        mdxz6: '打包下载（面单及拣货单）',
        mdxz7: '打包下载（订单号#跟踪号）',
        cjdd: '创建订单',
    },
    // 入库预报
    rukuyubao: {
        Inbound_Forecast: '入库预报',//入库预报
        Select_Warehouse: '选择仓库',//选择仓库
        Shipping_Method: '运输方式',//运输方式
        Inbound_Remarks: '入库备注',//入库备注
        Please_enter_remarks: '请输入备注信息',//请输入备注信息
        Inbound_Details: '入库详情',//入库详情
        Carton_Numbering_Rules: '箱号规则：',//箱号规则：
        Carton_numbers_should_use_digits: '1、箱号建议以数字: 1、2、3、4 表示，数字不同表示不同的箱子；相同的数字表示同一个箱子。',//1、箱号建议以数字: 1、2、3、4
        // 表示，数字不同表示不同的箱子；相同的数字表示同一个箱子。
        Update_Inbound_Forecast: '更新入库预报(Ctrl+S)',//更新入库预报(Ctrl+S)
        Submit_Inbound_Forecast: '提交入库预报(Ctrl+S)',//提交入库预报(Ctrl+S)
        Cancel: '取消',//取消
        Insert_Row_Above: '上面插入一行',//上面插入一行
        Insert_Row_Below: '下面插入一行',//下面插入一行
        Insert_Row_Left: '左侧插入一列',//左侧插入一列
        Insert_Column_Right: '右侧插入一列',//右侧插入一列
        Remove_Row: '移除本行',//移除本行
        Remove_Column: '移除本列',//移除本列
        Alignment: '对齐方式',//对齐方式
        Read_Only: '只读',//只读
        Copy: '复制',//复制
        Cut: '剪切',//剪切
        Clear_All_Cell_Data: '清空所有单元格数据',//清空所有单元格数据
        Carton_No: '箱号',//箱号
        Quantity: '数量',//数量
        Tracking_Number: '跟踪号',//跟踪号
        Please_select_a_warehouse: '请选择仓库',//请选择仓库
        Please_select_a_shipping_method: '请选择运输方式',//请选择运输方式
        Maximum_entries_allowed: '预报条数只能300条',//预报条数只能300条
        Batch_No_Carton_No_Container_No: '批次号/箱号/柜号',//批次号/箱号/柜号
        one: 'one',//1

    },
    // 新增
    // 库存调仓
    kcdcRun: {
        Source_Warehouse: '来源仓',//来源仓
        Destination_Warehouse: '目的仓',//目的仓
        Transfer_Time: '调仓时间',//调仓时间
        Remarks: '备注',//备注
        Details: '详情',//详情
        Product_Name: '产品名称',//产品名称
        Transfer_Quantity: '调仓数量',//调仓数量
        Pending: '待处理',//待处理
        Processing: '处理中',//处理中
        Dispatched: '已发出',//已发出
        Completed: '已完成',//已完成
    },
    // sku管理
    p_skugl: {
        Add_SKU_Mapping: '添加映射SKU',//添加映射SKU
        SKU_List: 'SKU列表',//SKU列表
        Mapped_SKU_List: '映射SKU列表',//映射SKU列表
        Bulk_Delete_Mapped_SKUs: '批量删除映射SKU',//批量删除映射SKU
        System_SKU: '系统SKU',//系统SKU      
        Creation_Time: '创建时间',//创建时间
        Shipping_Information: '配送信息',//配送信息
        System_SKU_Quantity: '系统sku/数量/中文名/英文名/备注/图片',//系统sku/数量/中文名/英文名/备注/图片
        Quantity: '数量',//数量
        Chinese_Name: '中文名称',//中文名称
        English_Name: '英文名',//英文名
        Image: '图片',//图片
        Actions: '操作',//操作
        Map_SKU: '映射SKU',//映射SKU
        Add_SKU: '添加SKU',//添加SKU
        Keyword: '关键字',//关键字
        Please_enter_keyword: '请输入关键字(SKU,产品名称)',//请输入关键字(SKU,产品名称)
        Export_Data: '导出数据',//导出数据
        Barcode: '条形码',//条形码
        Product_NameC: '产品名称(中)',//产品名称(中)
        Product_NameE: '产品名称(英)',//产品名称(英)
        Dimensions: '长宽高(cm)',//长宽高(cm)
        Weight: '重量(kg)',//重量(kg)
        SKU_Declared_Value: 'SKU申报价值',//SKU申报价值
        Contains_Battery: '是否带电',//是否带电
        No: '否',//否
        Yes: '是',//是
        Product_Link: '产品链接',//产品链接
        SKU_Image: 'SKU图片',//SKU图片
        Purchase_URL: '采购网址',//采购网址
        Remarks: '备注',//备注
        Forecast_Time: '预报时间',//预报时间
        Color: '颜色',//颜色
        Sensitive_Item: '是否敏感',//是否敏感
        Package_Shape: '外包装形状',//外包装形状
        Irregular_Shape: '不规则形状',//不规则形状
        Rectangular_Box: '长方体',//长方体
        Cylinder: '圆柱体',//圆柱体
        Package_Type: '外包装类型',//外包装类型
        Hard_Packaging: '硬包装',//硬包装
        Soft_PackagingH: '软包装+硬物',//软包装+硬物
        Soft_PackagingS: '软包装+软物',//软包装+软物
        Sales_Link: '销售链接',//销售链接
        Manage: '管理',//管理
        Edit: '编辑',//编辑
        Edit_SKU: '编辑SKU',//编辑SKU
        Please_select: '请选择是否带电',//请选择是否带电
        Length: '长',//长
        Please_ente_product_lenght: '请输入产品长',//请输入产品长
        Width: '宽',//宽
        lease_enter_product_width: '请输入产品宽',//请输入产品宽
        Height: '高',//高
        Please_enter_product_height: '请输入产品高',//请输入产品高
        Please_enter_product_link: '请输入产品链接',//请输入产品链接
        Please_enter_purchase_URL: '请输入采购网址(请以https://或http://开头)',//请输入采购网址(请以https://或http://开头)
        Please_enter_remarks: '请输入备注',//请输入备注
        Confirm_Edit: '确认编辑(Ctrl+S)',//确认编辑(Ctrl+S)
        Cancel: '取消',//取消
        Select_Template: '选择模板',//选择模板
        Upload_File: '上传文件',//上传文件
        Drag_file_here_or: '将文件拖到此处，或',//将文件拖到此处，或
        Click_to_Upload: '点击上传',//点击上传
        Only_Excel_files_allowed: '只能上传excel文件',//只能上传excel文件
        Max_limit_rows_in_xlsx_file: '（最大限制3000行.xlsx文件!）',//（最大限制3000行.xlsx文件!）
        If_the_mapped_SKU: '若映射SKU已被绑定过，是否解绑并与当前的系统SKU绑定？',//若映射SKU已被绑定过，是否解绑并与当前的系统SKU绑定？
        Confirm_Add: '确认添加(Ctrl+S)',//确认添加(Ctrl+S)
        Delete: '删除',//删除
        Are_you_sure_to_delete: '您确定要删除上一次提交映射的SKU吗?',//您确定要删除上一次提交映射的SKU吗?", "提示
        Confirm: '确定',//确定
        tip: '提示',//提示
    },
    // 添加sku
    jilu_sku_add: {
        SKU: 'SKU',//SKU
        Add_SKU: '添加SKU',//添加SKU
        Case_sensitivity_must_match: '注意大小写与入库预报一致',//注意大小写与入库预报一致
        Save: '保存(Ctrl+S)',//保存(Ctrl+S)
        Cancel: '取消',//取消
        Insert_Row_Above: '上面插入一行',//上面插入一行
        Insert_Row_Below: '下面插入一行',//下面插入一行
        Insert_Row_Left: '左侧插入一列',//左侧插入一列
        Insert_Column_Right: '右侧插入一列',//右侧插入一列
        Remove_Row: '移除本行',//移除本行
        Remove_Column: '移除本列',//移除本列
        Alignment: '对齐方式',//对齐方式
        Read_Only: '只读',//只读
        Copy: '复制',//复制
        Cut: '剪切',//剪切
        Clear_All_Cell_Data: '清空所有单元格数据',//清空所有单元格数据
        Cell_row: '单元格第',//单元格第
        Do_not_input: '行的',//行的
        Do_not_input_Chinese_characters: '请不要输入中文字符',//请不要输入中文字符
        No: '是',//是
        Yes: '否',//否
        Image_URL: '图片url',//图片url
        Product_Link: '产品链接',//产品链接
        Product_Name: '产品名称',//产品名称
        English_Name: '英文名称',//英文名称
        SKU_Declared_Value: 'SKU申报价值',//SKU申报价值
        Single_Weight: '单件重(kg)',//单件重(kg)
        Contains_Battery: '是否带电',//是否带电
        Length: '长(cm)',//长(cm)
        Width: '宽(cm)',//宽(cm)
        Height: '高(cm)',//高(cm)
        Non_sensitive: '不敏感',//不敏感
        Sensitive: '敏感',//敏感
        Irregular_Shape: '不规则形状',//不规则形状
        Rectangular_Box: '长方体',//长方体
        Cylinder: '圆柱体',//圆柱体
        Hard_Packaging: '硬包装',//硬包装
        Soft_PackagingH: '软包装+硬物',//软包装+硬物
        Soft_PackagingS: '软包装+软物',//软包装+软物
        Color: '颜色',//颜色
        Sensitive_Item: '是否敏感',//是否敏感
        Package_Shape: '外包装形状',//外包装形状
        Package_Type: '外包装类型',//外包装类型
        Sales_Link: '销售链接',//销售链接
        Please_enter_the_correct_SKU: '请输入正确的SKU',//请输入正确的SKU
    },
    // 新增订单列表
    hwddlilst: {
        batch: '批',//批
        Enable_Field: '启用字段',//启用字段
        Selected_fields_will_appear_in_the_Order_List: '选中的字段将在“订单列表”展现，反之不展现，请根据业务情况开启或关闭',//选中的字段将在“订单列表”展现，反之不展现，请根据业务情况开启或关闭
        Cancel: '取 消',//取 消
        OK: '确 定(Ctrl+S)',//确 定(Ctrl+S)
        Fields_displayed_in_the_template: '模板展示的字段',//模板展示的字段
        Click_to_show: '点击设置显示或者隐藏，左右拖动设置列顺序',//点击设置显示或者隐藏，左右拖动设置列顺序
        Fields_not_displayed: '模板不展示的字段',//模板不展示的字段
        Click_the_fiel_boxes_below: '点击下方字段方块，转入到表格展示的字段',//点击下方字段方块，转入到表格展示的字段
        Template_Name: '模板名称',//模板名称
        Export_Template_Name: '导出模板名称',//导出模板名称
        Sort: '排序',//排序
        Please_select: '请选择',//请选择
        Sorting_Rule: '排序规则',//排序规则
        Confirm_Add: '确认添加',//确认添加
        Confirm_Edit: '确认编辑',//确认编辑
        Create_Order: '创建订单',//创建订单
        Excel_Import: 'Excel导入',//Excel导入
        Keyword: '关键字',//关键字
        Please_enter_a_keyword: '请输入关键字(订单号/收件人/跟踪号/批量上传批次)',//请输入关键字(订单号/收件人/跟踪号/批量上传批次)
        Overseas_Warehouse: '海外仓库',//海外仓库
        Enter_Warehouse: '请输入仓库Id或者选择',//请输入仓库Id或者选择
        Select: '选',//选
        Shipping_Method: '运输方式',//运输方式
        Please_select_shipping_method: '请选择运输方式',//请选择运输方式
        Weight_Range: '重量范围',//重量范围
        Enter_weight_range: '请输入重量范围(kg)',//请输入重量范围(kg)
        Query_Method: '查询方式',//查询方式
        Please_select_batch_query_method: '请选择批量查询方式',//请选择批量查询方式
        Batch_query_by_Order_No: '订单号或跟踪号批量查询，每行一个(该查询只支持精确查询，不支持模糊查询)',//订单号或跟踪号批量查询，每行一个(该查询只支持精确查询，不支持模糊查询)
        Express_Query: '快递查询',//快递查询
        All: '全部',//全部
        Printed: '已打印',//已打印
        Unprinted: '未打印',//未打印
        Failed_Orders: '失败订单',//失败订单
        No_Refund: '无退款',//无退款
        Pending_Refund: '待退款',//待退款
        Refunded: '已退款',//已退款
        Non_refundable: '不能退款',//不能退款
        Frozen: '冻结中',//冻结中
        Check_Status: '查询状态',//查询状态
        Sync_Back_to_commerce_Platform: '回传电商平台',//回传电商平台
        Date_Range: '日期范围',//日期范围
        Start_Date: '开始日期',//开始日期
        End_Date: '结束日期',//结束日期
        Today: '今日',//今日
        Yesterday: '昨日',//昨日
        Last_7_Days: '近7日',//近7日
        Last_30_Days: '近30日',//近30日
        Additional_Charges: '补扣费用',//补扣费用
        Pending_Approval: '未审批',//未审批
        Approved: '已审批',//已审批
        Filtered_out: '已筛选出',//已筛选出
        order_records: '条订单信息',//条订单信息
        Filter: '筛选',//筛选
        Reset: '重置',//重置
        Sub_status: '子状态',//子状态
        Batch_Upload: '批量上传',//批量上传
        Batch_Upload_Tracking_Numbers: '批量上传跟踪号',//批量上传跟踪号
        Batch_Upload_Labels: '批量上传Labels',//批量上传Labels
        Pending_verification_orders: '待核销属于费用可能存在不准确的订单，该类订单会被冻结相应的金额，核销后会取消冻结并真实扣费。',//待核销属于费用可能存在不准确的订单，该类订单会被冻结相应的金额，核销后会取消冻结并真实扣费。
        Shipping_Label_Download: '面单下载',//面单下载
        Merge_Download: '合并下载',//合并下载
        Batch_DownloadO: '打包下载(按订单号)',//打包下载(按订单号)
        Batch_DownloadT: '打包下载(按跟踪号)',//打包下载(按跟踪号)
        Batch_DownloadW: '打包下载(按运单号)',//打包下载(按运单号)
        Return_Tracking_Number: '回传单号',//回传单号
        Confirm_Bill: '确认账单',//确认账单
        Select_Shipping_Channel: '选择快递渠道',//选择快递渠道
        Please_Select_Sender_Address: '请选择发件地址',//请选择发件地址
        Price_Estimation: '试算价格',//试算价格
        Generate_Shipping_Label: '生成快递单',//生成快递单
        Confirm_Shipment: '确认发货',//确认发货
        Retrieve_Again: '重新获取',//重新获取
        Request_Refund: '申请退款',//申请退款
        Delete: '删除',//删除
        Column_Template_Settings: '列模板设置',//列模板设置
        Export_Data: '导出数据',//导出数据
        Add_Template: '添加模板',//添加模板
        This_is_sample_content: '这是一段内容,这是一段内容,这是一段内容,这是一段内容。',//这是一段内容,这是一段内容,这是一段内容,这是一段内容。
        Select_All_Orders_in_Current_Status: '勾选当前状态下全部订单',//勾选当前状态下全部订单
        Click_to_Copy: '点击复制',//点击复制
        Postage_Fee: '邮费:',//邮费:
        Handling_Fee: '处理费:',//处理费:
        Registration_Fee: '挂号费:',//挂号费:
        Other_Fees: '其他费用:',//其他费用:
        Fuel_Surcharge: '燃油费:',//燃油费:
        Unable_to_View_Orders: '无法查看订单',//无法查看订单
        Processing_Orders: '正在出单',//正在出单
        Request_in_Progress: '请求中',//请求中
        Upload: '上传',//上传
        Double_click_this_Row_for_Same_Effect: '双击本行同效',//双击本行同效
        Upload_Shipping_Label_and: '上传面单及跟踪号发货',//上传面单及跟踪号发货
        Order_Number: '订单号',//订单号
        Tracking_Number: '跟踪号',//跟踪号
        Please_Enter_Tracking_Number: '请输入跟踪号',//请输入跟踪号
        Upload_Shipping_Label: '上传面单',//上传面单
        Click_to_Upload: '点击上传',//点击上传
        PDF_Files_Only: '只能上传PDF文件',//只能上传PDF文件
        Confirm_Shipment: '确认发货',//确认发货
        Generate: '生成SCANFORM',//生成SCANFORM
        OK1: '确认',//确认
        Order_Quantity: '订单数量',//订单数量
        Select_Status: '选择状态',//选择状态
        Please_Select_Order_Status: '请选择订单状态',//请选择订单状态
        Solution: '解决方案',//解决方案
        Click_Here: '点击此处',//点击此处
        Please_carefully_read_the_following_instructions: '请认真阅读以下提示：',//请认真阅读以下提示：
        Error_Tag: '1、报错标识：“接口报错”，该报错由接口（供应商）返回，需要联系供应商解决。',//1、报错标识：“接口报错”，该报错由接口（供应商）返回，需要联系供应商解决。
        Get_the_interaction: '2、获取 ShipOS 与 你们供应商 交互的JSON',//获取 ShipOS 与 你们供应商 交互的JSON
        Sen_the_interaction: '3、将交互JSON发给供应商，由供应商查询解决',//3、将交互JSON发给供应商，由供应商查询解决
        Not_queried_yet: '暂未查询',//暂未查询
        No_results_found: '查询不到',//查询不到
        Awaiting_pickup: '等待揽收',//等待揽收
        In_transit: '运输途中',//运输途中
        Arrived_for_pickup: '到达待取',//到达待取
        Delivery_failed: '投递失败',//投递失败
        Potential_exception: '可能异常',//可能异常
        Successfully_delivered: '签收成功',//签收成功
        Excessive_transit_time: '运输过久',//运输过久
        This_week: '本周',//本周
        This_month: '本月',//本月
        Last_month: '上月',//上月
        Last_7_days1: '最近一周',//最近一周
        Last_30_days2: '最近一个月',//最近一个月
        Last_90_days3: '最近三个月',//最近三个月
        Original_import_sequence: '原导入顺序',//原导入顺序
        Order_ID: '订单编号',//订单编号
        RemarksN: 'Note备注',//Note备注
        Shipping_channel: '运输渠道',//运输渠道
        Ascending: '升序',//升序
        Descending: '降序',//降序
        Close_search: '关闭搜索',//关闭搜索
        Test_Data: '黄金糕',//黄金糕
        Please_select_the_data_you_want: '请选择您要操作的数据',//请选择您要操作的数据
        This_action_will_approve_the_order: '此操作将会审批该条订单,是否继续？',//此操作将会审批该条订单,是否继续？
        Confirm_action: '确认操作',//确认操作
        This_will_select_all_orders_in_current_status: '该操作会勾选当前状态下的所有订单，是否继续操作',//该操作会勾选当前状态下的所有订单，是否继续操作
        Confirmation: '确认信息',//确认信息
        All_orders_in_current_status_selected: '已勾选当前状态下的全部订单',//已勾选当前状态下的全部订单
        Copied_successfully: '复制成功',//复制成功
        Please_select_shipping_method: '请选择运输方式',//请选择运输方式
        Please_select_status: '请选择状态',//请选择状态
        Error_message: '错误信息',//错误信息
        Maximum_one_file_allowed: '最多支持上传一个文件',//最多支持上传一个文件
        Only_pdf_files_allowed: '只能上传后缀是.pdf的文件',//只能上传后缀是.pdf的文件
        Please_upload_shipping_label: '请上传面单',//请上传面单
        Please_select_address: '请选择地址',//请选择地址
        Please_select_orders_for_refund_first: '请先选择要退款的订单',//请先选择要退款的订单
        This_will_submit_refund_request_Continue: '此操作将会为您申请退款, 是否继续?',//此操作将会为您申请退款, 是否继续?
        Notification: '提示',//提示
        No_data_selected: '您还未勾选数据',//您还未勾选数据
        File_read_error: '文件读取错误。',//文件读取错误。
        please_reselect_or_contact_admin: '文件错误,请重新选择或联系管理员',//文件错误,请重新选择或联系管理员
        This_action_cannot_be_undone: '此操作将不可恢复',//此操作将不可恢复
        Generating_waybill_will_charge_fees: '生成快递单将直接扣费，确认生成吗？',//生成快递单将直接扣费，确认生成吗？
        Please_select_at_least_three_fields: '请选择至少三个字段',//请选择至少三个字段
        This_will_permanently_delete_the_template: '此操作将永久删除该模板, 是否继续?',//此操作将永久删除该模板, 是否继续?
        Successfully_deleted: '删除成功',//删除成功
        Edit_template: '编辑模板',//编辑模板
        Close_search: '关闭搜索',//关闭搜索
        Enable_search: '开启搜索',//开启搜索
        Please_select_channel: '请选择渠道',//请选择渠道
        Price_estimation_completed: '试算价格已完成',//试算价格已完成
        Action: '操作',//操作
        Continue: '继续',//继续
        UI_Prompt: '请选择订单',//请选择订单
        Split_Order: '拆分订单',//拆分订单
    },
    //创建运单
    hwcarate_waybill: {
        Please_Enter_Recipient_Company: '请输入收件公司',//请输入收件公司
        Create_Shipping_Label: '创建运单',//创建运单
        Select_Warehouse: '选择仓库',//选择仓库
        Please_Select_Warehouse: '请选择仓库',//请选择仓库
        Quick: '快',//快
        Efficient: '捷',//捷
        Fill: '填',//填
        Write: '写',//写
        As_a_Noun: '地',//地
        Address: '址',//址
        Please_enter_exac_address_in_this_box: '请在本框中输入精确地址，如示例',//请在本框中输入精确地址，如示例
        Click_to_Parse_Address: '点击分解地址',//点击分解地址
        Enter_full_address_in_left_box: '在左框中输入完整地址，然后本按钮，自动分解地到到下方收件信息。',// 在左框中输入完整地址，然后本按钮，自动分解地到到下方收件信息。
        Saved_Addresses: '常用地址',//常用地址
        Please_Select_Saved_Shipping_Address: '请选择常用收件地址',//请选择常用收件地址
        FBA_Address: 'FBA地址',//FBA地址
        receiving_information: '收件信息',//收件信息
        Please_Select_FBA_Address: '请选择FBA地址',//请选择FBA地址
        Quick_Fill_Close: '快捷关闭填写',//快捷关闭填写
        Recipient_Information: '收件信息',//
        FBA_warehouse_addresses_may_change: '因FBA仓库地址会有变更的情况，使用快捷填写需要自行确认录入的地址是否准确！',//因FBA仓库地址会有变更的情况，使用快捷填写需要自行确认录入的地址是否准确！
        Recipient_Name: '收件姓名',//收件姓名
        Please_Enter_Recipient_Name: '请输入收件姓名',//请输入收件姓名
        Recipient_Phone: '收件电话',//收件电话
        Please_Enter_Recipient_Phone: '请输入收件电话',//请输入收件电话
        Recipient_Company: '收件公司',//收件公司
        Please_Enter_Recipient_Address: '请输入收件公司',//请输入收件公司
        Recipient_Address: '收件地址',//收件地址
        Please_Enter_Recipient_Address: '请输入收件地址',//请输入收件地址
        Address_Line: '延长地址',//延长地址
        Use_for_overflow_address_text: '当前地址过长时使用',//当前地址过长时使用
        City: '收件城市',//收件城市
        Please_Enter_City: '请输入收件城市',//请输入收件城市
        State_Province: '收件州省',//收件州省
        Please_Enter_State_Province: '请输入收件州省',//请输入收件州省
        Postal_Code: '收件邮编',//收件邮编
        Please_Enter_Postal_Code: '请输入收件邮编',//请输入收件邮编
        Destination_Country: '目的国家',//目的国家
        Please_Select_Country: '请选择国家',//请选择国家
        Select: '选',//选
        Order_Number: '订单编号',//订单编号
        generate_when_empty: '为空时自动生成',//为空时自动生成
        Custom_Remarks: '自定备注',//自定备注
        Mainly_used_for_label_notes: '请输入',//多用于Label上的备注
        Save_to_Address_Book: '保存到收件地址库',//保存到收件地址库
        Order_Settings: '订单设置',//订单设置
        Number_of_Boxes: '箱子数量',//箱子数量
        Same_Weight: '相同重量尺寸',//相同重量尺寸
        FBA_Shipment: 'FBA运单',//FBA运单
        Please_Enter: '请输入',//请输入
        Box_Number_Digits: '箱号位数',//箱号位数
        Please_Select: '请选择',//请选择
        Unit_Settings: '单位设置',//单位设置
        Tip: '小提示：',//小提示：
        You_can_edit_in_Excel_first: '可以在Excel中编辑好，复制并粘贴到下方表格。',//可以在Excel中编辑好，复制并粘贴到下方表格。
        Submit_Order: '提交订单(Ctrl+S)',//提交订单(Ctrl+S)
        Battery_Included: '带电',//带电
        Magnetic: '带磁',//带磁
        mph: '门牌号码',//门牌号
        Hazardous_Materials: '危险品',//危险品
        Liquid: '液体',//液体
        Powder: '粉末',//粉末
        Paste: '膏体',//膏体
        General_Goods: '普货',//普货
        Sensitive_Goods: '敏感货',//敏感货
        Wood_Products: '木制品',//木制品
        Textiles: '纺织品',//纺织品
        Enable_Quick_Fill: '开启快捷填写',//开启快捷填写
        Insert_Row_Above: '上面插入一行',//上面插入一行
        Insert_Row_bottom: '下面插入一行',//下面插入一行
        Insert_Column_Left: '左侧插入一列',//左侧插入一列
        Insert_Column_Right: '右侧插入一列',//右侧插入一列
        Delete_Row: '移除本行',//移除本行
        Delete_Column: '移除本列',//移除本列
        Alignment: '对齐方式',//对齐方式
        Read_only: '只读',//只读
        Copy: '复制',//复制
        Cut: '剪切',//剪切
        Clear_All_Cell_Data: '清空所有单元格数据',//清空所有单元格数据
        Quantity: '数量',//数量
        Auto_generate: '自动生成',//自动生成
        Minimum_1_box_required: '箱子数量至少为1个',//箱子数量至少为1个
        Please_enter_name: '请填写姓名',//请填写姓名
        Please_enter_phone: '请填写电话',//请填写电话
        Please_enter_city: '请填写城市',//请填写城市
        Please_enter_state_province: '请填写州省',//请填写州省
        Please_enter_country: '请填写国家',//请填写国家
        Please_enter_postal_code: '请填写邮编',//请填写邮编
        Please_fill_in_the_address: '请填写地址',//请填写地址
    },
    // 批量上传
    hwpiliang: {
        Bulk_Upload: '批量上传',//批量上传
        This_feature_only_supports_single_piece_orders: '该功能仅适用于单票单件的订单，一票多件的订单暂时不能批量导入。',//该功能仅适用于单票单件的订单，一票多件的订单暂时不能批量导入。
        Uploading_in_progress: '上传中，请勿刷新',//上传中，请勿刷新
        Excel_Template: 'Excel模板',//Excel模板
        Inventory_Shipping_Template: '库存发货模板',//库存发货模板
        Batc_Number: '订单批次：',//订单批次：
        Auto_generate_if_empty: '为空时自动生成',//为空时自动生成
        Warehouse_Matching: '匹配仓库：',//匹配仓库：
        Not_Matched: '不匹配',//不匹配
        Matched: '匹配',//匹配
        Select_Warehouse: '选择仓库',//选择仓库
        Weight_Settings: '重量设置：',//重量设置：
        Upload_File: '上传文件：',//上传文件：
        Drag_file_here_or: '将文件拖到此处，或',//将文件拖到此处，或
        click_to_upload: '点击上传',//点击上传
        Excel_files_only: '只能上传excel文件',//只能上传excel文件
        Max_3000_rows_in: '（最大限制3000行.xlsx文件!）',//（最大限制3000行.xlsx文件!）
        Order_Quantity: '订单数量：',//订单数量：
        Upload_Excel: '上传EXCEL',//上传EXCEL
        Upload_History: '上传列表',//上传列表
        System_only_retains_Excel_import: '( 注意:系统仅保留30天的Excel导入记录! )',//( 注意:系统仅保留30天的Excel导入记录! )
        Bulk_Delete: '批量删除',//批量删除
        Module_Name: '模块名称',//模块名称
        Batch: '批次',//批次
        Download: '下载',//下载
        Order_Qty: '订单数量',//订单数量
        Success: '成功数量',//成功数量
        Failed: '失败数量',//失败数量
        Upload_Time: '上传时间',//上传时间
        Action: '操作',//操作
        Delete: '删除',//删除
        Please_select_data: '请勾选数据',//请勾选数据
        This_action_cannot_be_undone: '此操作将不可恢复',//此操作将不可恢复
        Alert: '提示',//提示
        Confirm: '确定',//确定
        Cancel: '取消',//取消
        Deleted_successfully: '删除成功',//删除成功
        Deletion_failed: '删除失败',//删除失败
        Data_older_than_30_days_has_been_purged: '已清除30天以外的数据',//已清除30天以外的数据
        Invalid_format_Please_upload: '上传格式不正确，请上传xls或者xlsx格式',//上传格式不正确，请上传xls或者xlsx格式
        Please_select_warehouse: '请选择仓库',//请选择仓库
        Please_upload_file_first: '请先上传文件',//请先上传文件
        File_cannot_exceed_3000_rows: '上传文件不能超过3000行',//上传文件不能超过3000行
        File: '文件',//文件
    },
    // 新增入库记录
    rukujilu: {
        SKU_Label_Configuration: '配置SKU标签',//配置SKU标签
        Width: '宽',//宽
        Height: '高',//高
        Top_Margin: '顶部距离',//顶部距离
        Barcode_Top_Margin: '条形码距离顶部距离,建议范围3—20',//条形码距离顶部距离,建议范围3—20
        Barcode_Height: '条形码高度',//条形码高度
        Barcode_HeightR: '条形码的高度,建议20',//条形码的高度,建议20
        Barcode_Length: '条形码长度',//条形码长度
        Barcode_LengthR: '条形码的长度,建议20',//条形码的长度,建议20
        Cancel: '取 消',//取 消
        Confirm: '确 定',//确 定
        Edit: '编辑',//编辑
        Product_Name: '产品名称',//产品名称
        Product_SKU: '产品SKU',//产品SKU
        Inbound_Quantity: '入库数量',//入库数量
        Unit_Weight: '单件重量',//单件重量
        Tracking_Remarks: '跟踪备注',//跟踪备注
        Tracking_Number: '跟踪号及相关备注信息',//跟踪号及相关备注信息
        Inbound_Forecast: '入库预报',//入库预报
        Manage_SKU: '管理SKU',//管理SKU
        Select_Warehouse: '请选择仓库',//请选择仓库
        All: '全部',//全部
        Start_Date: '开始日期',//开始日期
        End_Date: '结束日期',//结束日期
        Enter_Batch: '请输入批次/ID',//请输入批次/ID
        Enter_SKU: '请输入SKU',//请输入SKU
        Enter_Tracking_Number: '请输入跟踪号',//请输入跟踪号
        Enter_Internal_Box_Number: '请输入内部箱号',//请输入内部箱号
        Batch_Delete: '批量删除',//批量删除
        Batch_Print_PDF: '批量打印PDF',//批量打印PDF
        Batch_ID: '批次ID',//批次ID
        Warehouse: '仓库',//仓库
        Batch: '批次',//批次
        Total_Boxes: '总箱数',//总箱数
        SKU_Quantity: 'SKU数量',//SKU数量
        Product_Quantity: '产品数量',//产品数量
        Inbound_Box_Label: '入库箱贴',//入库箱贴
        Download_Warehouse_Receipt: '下载入仓单',//下载入仓单
        Remarks: '备注',//备注
        Status: '状态',//状态
        Forecast_Time: '预报时间',//预报时间
        Inbound_Time: '入库时间',//入库时间
        Edit: '编辑',//编辑
        Delete: '删除',//删除
        Box_ID: '箱号ID',//箱号ID
        Box_Number: '箱号',//箱号
        Internal_Box_Number: '内部箱号',//内部箱号
        Tracking_Number: '跟踪号',//跟踪号
        Quantity: '数量',//数量
        SKU_Inbound_ID: 'SKU入库ID',//SKU入库ID
        Inbound_Batch_ID: '入库批次ID',//入库批次ID
        Inbound_Box_ID: '入库箱号ID',//入库箱号ID
        Barcode: '条形码',//条形码
        Barcode_Natural: '条形码(自然序号)',//条形码(自然序号)
        Unit_Weight: '单件重(kg)',//单件重(kg)
        By_Batch: '按批次',//按批次
        By_Box_Number: '按箱号',//按箱号
        By_SKU: '按SKU',//按SKU
        Today: '今天',//今天
        Yesterday: '昨天',//昨天
        This_Week: '本周',//本周
        This_Month: '本月',//本月
        Last_Month: '上月',//上月
        Last_7_Days: '最近一周',//最近一周
        Last_30_Days: '最近一个月',//最近一个月
        Last_90_Days: '最近三个月',//最近三个月
        Please_select_the_data_to_print: '请选择要打印的数据',//请选择要打印的数据
        Please_select_the_data_you_want_to_operate: '请选择您要操作的数据',//请选择您要操作的数据
        File_read_error: '文件读取错误。',//文件读取错误。
        API_error_please_contact_the_administrator: '接口错误,请联系管理员',//接口错误,请联系管理员
        Please_select_the_data_to_operate: '请选择要操作的数据',//请选择要操作的数据
        Are_you_sure_you_want_to_delete: '您确定要删除吗',//您确定要删除吗
        Prompt: '提示',//提示
        SKU_Box_Label: 'SKU箱贴',//SKU箱贴
        Actions: '操作',//操作
        Query_Records: '查询记录',//查询记录
    },
    // 入库记录  管理sku
    jilu_skugl: {
        SKU_Management: '管理SKU',//管理SKU
        Enter_SKU_or_product_name: '请输入sku或产品名称',//请输入sku或产品名称
        Enter_mapping_SKU: '请输入映射SKU',//请输入映射SKU
        Search: '搜索',//搜索
        Export_data: '导出数据',//导出数据
        Batch_print_barcodes: '批量打印条形码',//批量打印条形码
        Mapping_SKU: '映射SKU',//映射SKU
        Import_SKU: '导入SKU',//导入SKU
        Add_SKU: '添加SKU',//添加SKU
        Enter_SKU_one_per_line_or_separated_by_commas: '请输入sku,每行一个或逗号隔开',//请输入sku,每行一个或逗号隔开
        Mapping_SKU: '映射SKU',//映射SKU
        Product_name: '产品名称',//产品名称
        SKU_declared_value: 'SKU申报价值',//SKU申报价值
        Weight: '重量(kg)',//重量(kg)
        DimensionsLWH: '长(cm)x宽(cm)x高(cm)',//长(cm)x宽(cm)x高(cm)
        Barcode: '条形码',//条形码
        Actions: '操作',//操作
        Delete: '删除',//删除
        Batch_import_SKU: '批量导入SKU',//批量导入SKU
        Select_template: '选择模板',//选择模板
        SKU_batch_import: 'SKU批量导入',//SKU批量导入
        Upload_file: '上传文件',//上传文件
        Drag_file_here_or: '将文件拖到此处，或',//将文件拖到此处，或
        Click_to_upload: '点击上传',//点击上传
        Excel_files_only: '只能上传excel文件',//只能上传excel文件
        Maximum_3000_rows: '（最大限制3000行.xlsx文件!）',//（最大限制3000行.xlsx文件!）
        Confirm_add: '确认添加(Ctrl+S)',//确认添加(Ctrl+S)
        Clear: '取消清空',//取消清空
        Yes: '是',//是
        No: '否',//否
        If_mapped_SKU_is_already_bound: '若映射SKU已被绑定过，是否解绑并与当前的系统SKU绑定？',//若映射SKU已被绑定过，是否解绑并与当前的系统SKU绑定？
        Cancel: '取消',//取消
        Edit_mapping_SKU: '编辑映射SKU',//编辑映射SKU
        System_SKU: '系统SKU',//系统SKU
        Multiple_mapping_SKUs_should_be: '多个映射SKU请用英文分号；分割',//多个映射SKU请用英文分号';'分割
        Edit_SKU_name: '编辑SKU名称',//编辑SKU名称
        Enter_product_name: '请输入产品名称',//请输入产品名称
        English_name: '英文名称',//英文名称
        Enter_English_name: '请输入英文名称',//请输入英文名称
        Please_select_at_least_one_SKU: '请至少选择一个sku',//请至少选择一个sku
        Confirm_to_delete_last_submitted_mapping_SKU: '您确定要删除上一次提交映射的SKU吗',//您确定要删除上一次提交映射的SKU吗
        Notification: '提示',//提示
        Confirm: '确定',//确定
        This_operation_will_delete_all_inbound: '该操作将删除所有入库及库存数据，确认删除吗',//该操作将删除所有入库及库存数据，确认删除吗
        Batch: '批',//批
        Confirm_Edit: '确认编辑(Ctrl+S)',//确认编辑(Ctrl+S)
    },
    // 库存管理
    skugl_p: {
        PAlert_Quantity: '请输入预警数量',//请输入预警数量
        Inbound_Forecast: '入库预报',//入库预报
        Manage_SKU: '管理SKU',//管理SKU
        Update_Inventory: '更新库存',//更新库存
        Keyword: '关键字',//关键字
        Enter_keyword: '请输入关键字(SKU/产品名称)',//请输入关键字(SKU/产品名称)
        Mapping_SKU: '映射SKU',//映射SKU
        Enter_Mapping_SKU: '请输入映射SKU',//请输入映射SKU
        No_Inventory: '无库存',//无库存
        Filtered_Results: '已筛选出',//已筛选出
        order_records: '条订单信息',//条订单信息
        Filter: '筛选',//筛选
        Reset: '重置',//重置
        Total_Inbound: '出入库总数量统',//出入库总数量统
        Inbound: '入库',//入库
        Outbound: '出库',//出库
        Remaining: '剩余',//剩余
        Pending_Inbound: '待入库',//待入库
        Inventory_Transfer: '库存调仓',//库存调仓
        Alert_Settings: '预警设置',//预警设置
        Export_Data: '导出数据',//导出数据
        SKU_Declared_Value: 'SKU申报价值',//SKU申报价值
        Contains_Battery: '是否带电',//是否带电
        Warehouse_Name: '仓库名称',//仓库名称
        Product_Name: '产品名称',//产品名称
        Inbound_Quantity: '入库数量',//入库数量
        Outbound_Quantity: '出库数量',//出库数量
        Remaining_Quantity: '剩余数量',//剩余数量
        Volume: '体积',//体积
        Total_Volume: '总体积',//总体积
        Unit_Weight: '单件重(kg)',//单件重(kg)
        Storage_Fee: '仓储费',//仓储费
        Monthly: '月',//月
        Per_item_Handling_Fee: '单件处理费',//单件处理费
        Per_item_Inbound_Fee: '单件入库费',//单件入库费
        Length: '长(cm)',//长(cm)
        Width: '宽(cm)',//宽(cm)
        Height: '高(cm)',//高(cm)
        Actions: '操作',//操作
        Edit: '编辑',//编辑
        Alert_Settings: '预警数量',//预警数量
        Alert_Quantity: '请输入预警数量',//请输入预警数量
        Enter_Alert_Quantity: '应用到全部',//应用到全部
        No: '否',//否
        Yes: '是',//是
        Confirm: '确认',//确认
        Cancel: '取消',//取消
        Edit_Dimensions: '编辑尺寸',//编辑尺寸
        Cargo_Dimensions: '货物尺寸',//货物尺寸
        Enter_Length: '请输入长',//请输入长
        Enter_Width: '请输入宽',//请输入宽
        Enter_Height: '请输入高',//请输入高
        Close_Search: '关闭搜索',//关闭搜索
        Select_Data_for_Alert_Setting: '请选择要设置预警的数据',//请选择要设置预警的数据
        Open_Search: '开启搜索',//开启搜索
        This_action_will_delete_the_SKU: '该操作删除SKU的同时，将会同时删除所有的入库记录，确认删除吗？',//该操作删除SKU的同时，将会同时删除所有的入库记录，确认删除吗？
        tip: '提示',//提示
    },
    // 订单列表  编辑详情
    gnpop: {
        Order_Details: '订单详情',//订单详情
        Close: '关闭',//关闭
        Tracking_Number: '运单号:',//运单号:
        Click_to_Copy: '单击复制',//单击复制
        Customer_Reference: '客户单号:',//客户单号:
        Click_to_Copy: '单击复制',//单击复制
        Internal_ID: '内部ID:',//内部ID:
        Refresh: '刷新',//刷新
        Print_System_Label: '打印系统标签',//打印系统标签
        Copy_Order: '复制订单',//复制订单
        Basic_Information: '基础信息',//基础信息
        Service_Type: '服务类型',//服务类型
        Not_Applicable: '暂无',//暂无
        Destination_Country: '发往国家',//发往国家
        Actual_Weight: '实际重量',//实际重量
        Volumetric_Weight: '体积重量',//体积重量
        Chargeable_Weight: '计费重量',//计费重量
        Cubic_Measurement: '方数',//方数
        Dimensional_Weight: '材积数',//材积数
        Number_of_Boxes: '箱数',//箱数
        Zone: '分区',//分区
        Fee: '费',//费
        Usage: '用',//用
        Postage_Fee: '邮费',//邮费
        Registration_Fee: '挂号费',//挂号费
        Handling_Fee: '处理费',//处理费
        Fuel_Surcharge: '燃油费',//燃油费
        Other_Fees: '其他杂费',//其他杂费
        Pending_Verification: '待核销',//待核销
        Total: '总计',//总计
        Refund: '退款',//退款
        on: '于',//于
        Request: '申请',//申请
        Shipping_Address: '收件地址',//收件地址
        Edit: '编辑',//编辑
        Customer_Notes: '客户备注',//客户备注
        Enter_notes: '请输入备注',//请输入备注
        Routing_Information: '路由信息',//路由信息
        Related_Information: '相关信息',//相关信息
        Yes: '是',//是
        No: '否',//否
        Please_Enter: '请输入',//请输入
        Required: '[必填]',//[必填]
        Carton_Information: '货箱信息',//货箱信息
        System_Carton_ID: '系统箱号',//系统箱号
        Dimensions: '尺寸',//尺寸
        Actual_Weight: '实重',//实重
        Chargeable_Weight: '本箱取值重量',//本箱取值重量
        Volumetric_Weight: '体积重',//体积重
        Copy: '复制',//复制
        By_Shipment: '[按票]',//[按票]
        By_Carton: '[按箱]',//[按箱]
        Declaration_Information: '申报信息',//申报信息
        Total_Products: '产品总数：',//产品总数：
        Declared_Total_Value: '申报总价值：',//申报总价值：
        Total_Purchase_Price: '采购总价：',//采购总价：
        Product_Items: '品名数量：',//品名数量：
        Cost_Information: '费用信息',//费用信息
        Fee_Type: '费用类型',//费用类型
        Billing_Unit: '收费单位',//收费单位
        Fee_Per_Unit: '每单位费',//每单位费
        Currency: '费用币种',//费用币种
        Exchange_Rate: '收费汇率',//收费汇率
        Fee_Description: '费用描述',//费用描述
        Internal_Notes: '内部备注',//内部备注
        Transaction_Time: '业务时间',//业务时间
        Charges: '费用',//费用
        Order_Fees_Under_Audit: '订单费用审计中.....',//订单费用审计中.....
        Attachments: '附件',//附件
        Upload_Attachment: '上传附件',//上传附件
        Upload_FBA_Label: '上传FBA标签',//上传FBA标签
        Upload_Time: '上传时间',//上传时间
        Uploaded_By: '上传人',//上传人
        Delete: '删除',//删除
        Work_Order: '工单',//工单
        Add: '添加',//添加
        Work_Order_Content: '工单内容',//工单内容
        Status: '状态',//状态
        Creation_Time: '创建时间',//创建时间
        Last_Reply: '最后回复',//最后回复
        Battery_Included: '带电',//带电
        Magnetic: '带磁',//带磁
        Hazardous_Materials: '危险品',//危险品
        Liquid: '液体',//液体
        Powder: '粉末',//粉末
        Paste: '膏体',//膏体
        General_Cargo: '普货',//普货
        Sensitive_Goods: '敏感货',//敏感货
        Wooden_Products: '木制品',//木制品
        Textiles: '纺织品',//纺织品
        Sum_chargeable_weight: '取每个箱子 实重抛重大数后合计',//取每个箱子 实重抛重大数后合计
        Total_chargeable_weight: '取所有箱子 实重抛重相加后大数',//取所有箱子 实重抛重相加后大数
        Sum_actual_weight: '取所有箱子 实重相加',//取所有箱子 实重相加
        Sum_volumetric_weight: '取所有箱子 体积重相加',//取所有箱子 体积重相加
        Charge_by_actual_weight: '按实重计费',//按实重计费
        Charge_by_volumetric_weight: '按体积重计费',//按体积重计费
        Charge_by_greater_of_actual: '按实重体积重大数计费',//按实重体积重大数计费
        Basic_Information: '基础信息',//基础信息
        Address_Routing: '地址路由',//地址路由
        Carton_Information: '货箱信息',//货箱信息
        Declaration_Info: '申报信息',//申报信息
        Cost_Information: '费用信息',//费用信息
        Attachments: '附件工单',//附件工单
        Copied_successfully: '复制成功!',//复制成功!
        Loading: '玩命加载中',//玩命加载中
        File_read_error: '文件读取错误。',//文件读取错误。
        API_error: '接口错误,请联系管理员',//接口错误,请联系管理员
        This_will_permanently_delete_the_file: '此操作将永久删除该文件, 是否继续?',//此操作将永久删除该文件, 是否继续?
        Notification: '提示',//提示
        Confirm: '确定',//确定
        Cancel: '取消',//取消
        Deletion_cancelled: '已取消删除',//已取消删除
        File_size_cannot_exceed: '上传文件大小不能超过 5MB!',//上传文件大小不能超过 5MB!
        Carton_No: '箱号',//箱号
        Weight: '重量',//重量
        Length: '长',//长
        Width: '宽',//宽
        Height: '高',//高
        Billing_Method: '计费方式：',//计费方式：
        Chargeable_Weight: '计费重量：',//计费重量：
        This_Shipments_Chargeabl_Weight: '本票取值重量',//本票取值重量
        File_Name: '文件名称',//文件名称
        Actions: 'Actions',//操作
        Total: '总计：',//总计：
    },
    // 订单列表  批量上传跟踪号
    openGenzong: {
        Batch_Upload_Tracking_Numbers: '批量上传跟踪号',//批量上传跟踪号
        Download_template: '下载模板',//下载模板
        Download: '下载',//下载
        Import_data: '导入数据',//导入数据
        Drag_file_here_or: '将文件拖到此处，或',//将文件拖到此处，或
        Click_to_upload: '点击上传',//点击上传
        Upload_Excel: '上传EXCEL',//上传EXCEL
        Cancel: '取消',//取消
        Please_upload_the_file: '请上传文件',//请上传文件
    },
    //库存记录  添加调仓
    InventoryAdjustment: {
        Add_Transfer: '添加调仓',//添加调仓
        Select_Transfer: '选择调仓',//选择调仓
        Select_SKUs_to_Transfer: '选择需要转移的SKU',//选择需要转移的SKU
        Destination_Warehouse: '目的仓库',//目的仓库
        Please_Select_Destination_Warehouse: '请选择目的仓库',//请选择目的仓库
        Warehouse_Name: '仓库名称',//仓库名称
        Transfer_Quantity: '转移数量',//转移数量
        Remaining_Quantity: '剩余数量',//剩余数量
        Inbound_Quantity: '入库数量',//入库数量
        Outbound_Quantity: '出库数量',//出库数量
        Volume: '体积',//体积
        Transfer_Remarks: '调仓备注',//调仓备注
        Please_Enter_Content: '请输入内容',//请输入内容
        SKU_List: 'SKU列表',//SKU列表
        Current_Transfer_List: '当前调仓表',//当前调仓表
        Action: '操作',//操作
        Save: '保存(Ctrl+S)',//保存(Ctrl+S)
        Cancel: '取消',//取消
        Add_to_Transfer_List: '加入调仓表',//加入调仓表
        Complete_Transfer: '完成调仓',//完成调仓
        Operation_Successful: '操作成功',//操作成功
        back: 'Back',//返回

    },
    //海外订单列表 编辑详情弹窗
    haiwaipop: {
        Order_Number: '订单号：',//订单号：
        Click_to_Copy: '单击复制',//单击复制
        Internal_ID: '内部ID:',//内部ID:
        Refresh: '刷新',//刷新
        Download_Label: '下载Label',//下载Label
        Copy_Order: '复制订单',//复制订单
        // Base: '基',//基
        // Foundation: '础',//础
        // Information: '信',//信
        // Information: '息',//息
        Basic_Information: '基础信息',//基础信息

        Service_Type: '服务类型',//服务类型
        None: '暂无',//暂无
        Destination_Country: '发往国家',//发往国家
        Actual_Weight: '实际重量',//实际重量
        Volumetric_Weight: '体积重量',//体积重量
        Billing_Weight: '计费重量',//计费重量
        Dimensional_Volume: '材积数',//材积数
        Number_of_Boxes: '箱数',//箱数
        Zone: '分区',//分区
        Fee: '费',//费
        Usage: '用',//用
        Shipping_Fee: '邮费',//邮费
        Registration_Fee: '挂号费',//挂号费
        Handling_Fee: '处理费',//处理费
        Fuel_Surcharge: '燃油费',//燃油费
        Other_Miscellaneous_Fees: '其他杂费',//其他杂费
        Orders_with_potentially: '冻结中属于费用可能存在不准确的订单，该类订单会被冻结相应的金额，核销后会取消冻结并真实扣费。',//冻结中属于费用可能存在不准确的订单，该类订单会被冻结相应的金额，核销后会取消冻结并真实扣费。
        Frozen: '冻结中',//冻结中
        Total: '总计',//总计
        Refund: '退款',//退款
        On: '于',//于
        Apply: '申请',//申请
        repair: '补',//补
        receive: '收',//收
        Order_ID: '订单id',//订单id
        Sub_Order_Field: '子订单字段',//子订单字段
        Channel_Description: '渠道简介',//渠道简介
        Approval_Fee: '审批费用',//审批费用
        Fee: '费用',//费用
        Creation_Time: '创建时间',//创建时间
        Unapproved: '未审批',//未审批
        Approved: '已审批',//已审批
        Shipping_Address: '收件地址',//收件地址
        Edit: '编辑',//编辑
        Sender_Address: '发件地址',//发件地址
        Select: '选择',//选择
        Routing_Information: '路由信息',//路由信息
        Customer_Remarks: '客户备注',//客户备注
        Price_Estimation: '试算价格',//试算价格
        Click_Channel_to_Create_Order: '点击渠道进行出单',//点击渠道进行出单
        This_channel_is_locked: '该渠道锁定以下地址',//该渠道锁定以下地址
        Current_Status: '当前状态:',//当前状态:
        Loaded_into_Container: '已装柜',//已装柜
        Container_Information: '货箱信息',//货箱信息
        System_Box_No: '系统箱号',//系统箱号
        Actual_Weight: '实重',//实重
        Shipping_Information: '发货信息',//发货信息
        Product_Name: '产品名称',//产品名称
        SKU_Image: 'SKU图片',//SKU图片
        Declared_Unit_Price: '申报单价',//申报单价
        Quantity: '数量',//数量
        Declaration_Information: '申报信息',//申报信息
        Total_Products: '产品总数：',//产品总数：
        Total_Declared_Value: '申报总价值：',//申报总价值：
        Total_Purchase_Price: '采购总价：',//采购总价：
        Product_Quantity: '品名数量：',//品名数量：
        Box_No: '箱号',//箱号
        Product_SKU: '商品SKU',//商品SKU
        Chinese_Product_Name: '中文品名',//中文品名
        English_Product_Name: '英文品名',//英文品名
        Material: '材质',//材质
        Purpose: '用途',//用途
        Product_Weight: '产品重量',//产品重量
        HS_Code: '海关编码',//海关编码
        Battery_Description: '电池描述',//电池描述
        Status: '状态',//状态
        Time: '时间',//时间
        Basic_Information: '基础信息',//基础信息
        Address_Routing: '地址路由',//地址路由
        Operation_Log: '操作日志',//操作日志
        Loading: '玩命加载中',//玩命加载中
        Copied_Successfully: '复制成功',//复制成功
        Please_Select_Sender_Address: '请选择发件地址',//请选择发件地址
        Total_Weight: '总重量',//总重量
        Add: '添加',//添加
        Dimensions: '尺寸',//尺寸
        Close: '关闭',//关闭
    },
    // 海外发货  仓租提醒
    daishouCz: {
        Storage_overdue_rate_multiplier: '仓租超期倍率',//仓租超期倍率
        SKU_inbound_ID: 'SKU入库ID',//SKU入库ID
        End_date: '结束日期',//结束日期
        Start_date: '开始日期',//开始日期
        Reset: '重置',//重置
        Export: '导出',//导出
        Warehouse_name: '仓库名称',//仓库名称
        Actual_inbound_quantity: '实入数量',//实入数量
        Remaining_quantity: '剩余数量',//剩余数量
        Storage_fee_unit_price: '仓储费单价',//仓储费单价
        Storage_rental_due: '仓租到期(天)',//仓租到期(天)
        Storage_overdue: '仓租超期',//仓租超期
        day: '天',//天
        Received: '已收(次)',//已收(次)
        Inbound_time: '入库时间',//入库时间
        Current_Rental_Cycle_Start_Time: '入库本次收租周期时间',//入库本次收租周期时间
        Warehouse_Rental: '仓租',//仓租
        Quantity: '数量',//数量
        Volume: '体积',//体积
        Rental_Collection_Time: '收租时间',//收租时间
        Amount: '金额',//金额
        Rental_Reminder: '仓租提醒（90天内）',//仓租提醒（90天内）
        Received_Records: '已收记录',//已收记录
        Please_Select_Time_Range: '请选择时间范围',//请选择时间范围
        All: '全部',//全部
        Inbound_Days: '入库天数',//入库天数
    },
    // 海外发货  仓租提醒 仓租超期倍率
    chaoqibeilv: {
        Overdue_Storage_Fee_Multiplier: '仓租超期倍率',//仓租超期倍率
        Xth_Month_After_Free_Storage_Period: '免租期后第',//免租期后第(x)月
        Storage_Fee_Unit_Price_Multiplier: '仓储费单价倍率',//仓储费单价倍率
    },
    // sku管理 添加映射sku
    z_addyingshe: {
        SKU_Mapping_Added_Successfully: '添加映射SKU成功',//添加映射SKU成功
        Add_SKU_Mapping: '添加映射SKU',//添加映射SKU
        Edit_SKU_Mapping: '编辑映射SKU',//编辑映射SKU
        SKU_Mapping: '映射SKU',//映射SKU
        Enter_Mapped_SKU: '请输入映射SKU',//请输入映射SKU
        System_SKU: '系统SKU',//系统SKU
        Enter_System_SKU: '请输入系统SKU',//请输入系统SKU
        Enter_Quantity: '请输入数量',//请输入数量
        Cancel: '取消',//取消
        Remark: '备注'
    },
    // 订单列表 拆分订单
    Caifen_pofeitou: {
        Split_Order: '拆分订单',//拆分订单
        Quantity: '数量',//数量
        Declared_Unit_Price: '申报单价',//申报单价
        Please_Select_SKU: '请选择sku',//请选择sku
        Please_Enter_Quantity: '请输入数量',//请输入数量
        Confirm_Split: '确认拆分(Ctrl+S)',//确认拆分(Ctrl+S)
        Order_Split_Successfully: '拆分成功',//拆分成功
        Cancel: '取消',//取消
        Quantity_cannot_exceed_original_SKU_quantity: '数量不能大于原SKU数量',//数量不能大于原SKU数量
    },
    // 拆分订单数量
    caifen_num: {
        Split_Order_Quantity: '拆分订单数量',//拆分订单数量
        Enter_Split_Quantity: '请输入拆分数量',//请输入拆分数量
        Cancel: '取 消',//取 消
        Confirm: '确 定',//确 定
    },
    // 编辑发货
    hottable: {
        Shipment_Editing: '编辑发货',//编辑发货
        Cancel: '取 消',//取 消
        Confirm: '确 定(Ctrl+S)',//确 定(Ctrl+S)
        Quantity: '数量',//数量
        Declared_Unit_Price: '申报单价',//申报单价
    },
    // 订单列表 编辑收件信息
    xqedit: {
        Edit_Recipient_Information: '编辑收件信息',//编辑收件信息
        Order_ID: '订单ID',//订单ID
        Please_enter_Order_ID: '请输入订单ID',//请输入订单ID
        Company_Name: '公司名称',//公司名称
        Please_enter_Company_Name: '请输入公司名称',//请输入公司名称
        Address_Lin_1: '地址一',//地址一
        Please_enter_Address_Line_1: '请输入地址一',//请输入地址一
        Country: '国家',//国家
        Please_select_Country: '请选择国家',//请选择国家
        City: '城市',//城市
        Please_enter_City: '请输入城市',//请输入城市
        House: '门牌号',//门牌号
        Please_enter_House: '请输入门牌号',//请输入门牌号
        Recipient_Name: '收件姓名',//收件姓名
        Please_enter_Recipient_Name: '请输入收件姓名',//请输入收件姓名
        Phone_Number: '电话号码',//电话号码
        Please_enter_Phone_Number: '请输入电话号码',//请输入电话号码
        Address_Line_2: '地址二',//地址二
        Please_enter_Address_Line_2: '请输入地址二',//请输入地址二
        State_Province: '州/省',//州/省
        Please_enter_State_Province: '请输入州/省',//请输入州/省
        Postal_Code: '邮编',//邮编
        Please_enter_Postal_Code: '请输入邮编',//请输入邮编
        Update_Address: '更新地址(Ctrl+S)',//更新地址(Ctrl+S)
        Frequently_Used: '常用',//常用
        Sender: '发件',//发件 
        Please_enter_Address_Alias: '请输入地址别名',//请输入地址别名
        Please_enter_country: '请输入国家',//请输入国家
        Please_enter_Sender_Name: '请输入发件姓名',//请输入发件姓名

    },
    // 入库记录 双击详情
    rukuxinqging: {
        Batch: '批次：',//批次：
        Carton_No: '箱号：',//箱号：
        Warehouse: '仓库',//仓库
        Carton_Number: '箱号',//箱号
        Product_Name: '产品名称',//产品名称
        Status: '状态',//状态
        Estimated_Quantity: '预报数量',//预报数量
        Actual_Received_Quantity: '实到数量',//实到数量
        Estimated_Weight: '预报重量(kg)',//预报重量(kg)
        Actual_Weight: '实际重量(kg)',//实际重量(kg)
        Dimensions: '长宽高(cm)',//长宽高(cm)
        Remarks: '备注',//备注
        Handling_Fee: '处理费/件',//处理费/件
        Storage_Fee: '入库费/件',//入库费/件
        Export: '导出',//导出
        Export_succeeded: '导出成功',//导出成功
    },
    //库存管理 双击详情
    inventorydetail: {
        Inventory_Details: '库存详情',//库存详情
        Warehouse_Name: '仓库名称',//仓库名称
        Product_SKU: '产品SKU',//产品SKU
        Shelf_Location: '货架位置',//货架位置
        Storage_Fee_per_Unit: '仓储费单价',//仓储费单价
        Remaining_Quantity: '剩余数量',//剩余数量
        Shipped_Quantity: '已发货数量',//已发货数量
        Total_Inbound_Quantity: '总入库数量',//总入库数量
        Single_Inbound_Fee: '单件入库费',//单件入库费
        Dimensions: '长宽高(cm)',//长宽高(cm)
        Weight: '重量(kg)',//重量(kg)
        Single_Handling_Fee: '单件处理费',//单件处理费
        Export_Outbound_Records: '导出出库记录',//导出出库记录
        Inbound_Records: '入库记录',//入库记录
        Outbound_Records: '出库记录',//出库记录
    },
    // 平台管理  平台账号
    P_ptzh: {
        Bind_Platform_Account: '绑定平台账号',//绑定平台账号
        Platform: '平台',//平台
        All: '全部',//全部
        Status: '状态',//状态
        Store_Name: '店铺名称',//店铺名称
        Please_enter_keywords: '请输入关键字(店铺名称)',//请输入关键字(店铺名称)
        Platform_Name: '平台名称',//平台名称
        Account_Status: '账号状态',//账号状态
        Enable: '启用',//启用
        Disable: '禁用',//禁用
        Creation_Time: '创建时间',//创建时间
        Store_SKU: '店铺SKU',//店铺SKU
        Add_SKU: '添加SKU',//添加SKU
        Actions: '操作',//操作
        Fetch_Orders: '拉取订单',//拉取订单
        Manage: '管理',//管理
        Edit: '编辑',//编辑
        Delete: '删除',//删除
        Fetch_Time: '拉取时间',//拉取时间
        Select_Date: '选择日期',//选择日期
        Fetch_Type: '拉取类型',//拉取类型
        Fetch_Orders_Only: '仅拉取订单',//仅拉取订单
        Shipping_LabelT: '面单(转入订单)',//面单(转入订单)
        Shipping_LabelA: '面单(自动出单)',//面单(自动出单)
        Channel_Selection: '渠道选择',//渠道选择
        Please_select_channel: '请选择渠道选择',//请选择渠道选择
        Fetch: '拉 取',//拉 取
        Cancel: '取 消',//取 消
        Confirm_to_delete_this_account: '确认删除该账号？',//确认删除该账号？
    },
    //   平台账号  绑定平台账号
    zhadd_drawer: {
        Edit_Bound_Platform_Account: '编辑绑定平台账号',//编辑绑定平台账号
        Bind_Platform_Account: '绑定平台账号',//绑定平台账号
        Auto_Transfer: '是否自动转入',//是否自动转入
        No: '否',//否
        Yes: '是',//是
        Order_Module: '订单模块',//订单模块
        Select_Warehouse: '选择仓库',//选择仓库
        Please_Select_Warehouse: '请选择仓库',//请选择仓库
        Select_Platform: '选择平台',//选择平台
        Account_Authorization: '账号授权',//账号授权
        Click_Here_to_Authorize_U: '点击此处开始授权(美国)',//第一步：点击此处开始授权(美国)
        Click_Here_to_Authorize_O: '点击此处开始授权(其它地区)',//第一步：点击此处开始授权(其它地区)
        Click_Here_to_Authorize_y: '中国跨境商家授权',//第一步：点击此处开始授权(其它地区)
        Existing_Account: '已有账号',//已有账号
        Store_Name: '店铺名称',//店铺名称
        Please_Enter_Store_Name: '请输入店铺名称',//请输入店铺名称
        Cannot_Be_Empty: '不能为空',//不能为空
        Please_Fill_In: '请填写',//请填写
        Confirm_Edit_Binding: '确认编辑绑定(Ctrl+S)',//确认编辑绑定(Ctrl+S)
        Confirm_Binding: '确认绑定(Ctrl+S)',//确认绑定(Ctrl+S)
        Cancel: '取消',//取消
        Please_Select_Platform_to_Bind: '请选择绑定的平台',//请选择绑定的平台
        Please_Enter_Store_Name: '请输入店铺名称',//请输入店铺名称
        Select: '选',//选
        Temporary_orders: '临时订单',//临时订单
        Transferred_orders: '已转入订单',//已转入订单
    },
    // 临时订单列表
    lsddList: {
        Please_enter_platform: '请输入平台/订单号',//请输入平台/订单号
        Transferred_orders: '已转入订单',//已转入订单
        Generate_order: '生成订单',//生成订单
        Menu_selection: '菜单选择',//菜单选择
        Select_warehouse: '选择仓库',//选择仓库
        Please_select_warehouse: '请选择仓库',//请选择仓库
        Select_channel: '选择渠道',//选择渠道
        Please_select_channel: '请选择渠道',//请选择渠道
        Select: '选',//选
        Confirm_generation: '确认生成(Ctrl+S)',//确认生成(Ctrl+S)
        Cancel: '取消',//取消
        Confirm: '确 定',//确 定
        Cancel_order: '取消订单',//取消订单
        Please_select_failure_reason: '请选择失败原因',//请选择失败原因
        Cancellation_successful: '取消成功',//取消成功
        Failed_to_set_label: '设置标签失败，请稍后再试',//设置标签失败，请稍后再试
        Setup_successful: '设置成功',//设置成功
        Please_select_orders_to_operate: '请选择要操作的订单',//请选择要操作的订单
        Failed_to_get_order_list: '获取订单列表失败',//获取订单列表失败
        All: '全部',//全部
        Temporary_orders: '临时订单',//临时订单
        Transferred_orders: '已转入订单',//已转入订单
    },
    // 临时订单列表 状态管理
    OrderTagManage: {
        Select: '选择',//选择
        Label_Name: '标签名称',//标签名称
        Please_enter_label_name: '请输入标签名称',//请输入标签名称
        Actions: '操作',//操作
        Edit: '修改',//修改
        Delete: '删除',//删除
        Save: '保存',//保存
        Add: '添加',//添加
        Undo: '撤销',//撤销
        SaveC: '保存(Ctrl+S)',//保存(Ctrl+S)
        Cancel: '取消',//取消
        Status_Label_Management: '状态标签管理',//状态标签管理
        Are_you_sure_you_want_to_delete_this_label: '是否确定删除此标签？',//是否确定删除此标签？
        Prompt: '提示',//提示
        Confirm: '确定',//确定
        Deletion_failed: '删除失败，请稍后再试',//删除失败，请稍后再试
        Label_name_cannot_be_empty: '标签名称不能为空',//标签名称不能为空
        Add_failed: '添加失败，请稍后再试',//添加失败，请稍后再试
        Edit_failed: '修改失败，请稍后再试',//修改失败，请稍后再试
        Failed_to_fetch_label_list: '获取标签列表失败',//获取标签列表失败
    },
    // 财务流水
    cwliusui: {
        Available: '可用',//可用
        Balance_Statistics: '余额统计',//余额统计
        Balance: '余额',//余额
        Credit_Line: '授信',//授信
        Temporary_Limit: '临额',//临额
        Expired: '过期:',//过期:
        Deposit: '押金',//押金
        Frozen: '冻结',//冻结
        Available_Credit: '可用额度',//可用额度
        Financial_Transactions: '财务流水',//财务流水
        Online_Recharge: '在线充值',//在线充值
        All: '全部',//全部
        Frozen_Amount: '冻结金额：',//冻结金额：
        Start_Date: '开始日期',//开始日期
        End_Date: '结束日期',//结束日期
        Keywords: '关键字',//关键字
        Query_Records: '查询记录',//查询记录
        Export: '导出',//导出
        The_monthly_amount_is_linked_to_account_balance: '该月度金额关联帐户余额，系统每天会自动从头再统计每个月的消费金额并写入数据库，然后得出帐户余额。',//该月度金额关联帐户余额，系统每天会自动从头再统计每个月的消费金额并写入数据库，然后得出帐户余额。
        Special_Note: '特别声明：如系统有使用提单功能，该充值计算是以提前创建日期为计算节点。',//特别声明：如系统有使用提单功能，该充值计算是以提前创建日期为计算节点。
        For_any_inquiries: '如有疑问，请联系技术咨询。',//如有疑问，请联系技术咨询。
        Click_to_manually_update: '点击手动更新',//点击手动更新
        Finance_ID: '财务ID',//财务ID
        Category: '类别',//类别
        Account: '账户',//账户
        Estimated_Amount: '预报金额',//预报金额
        Actual_Received_Amount: '实入金额',//实入金额
        Status: '状态',//状态
        Remarks: '备注',//备注
        Description: '说明',//说明
        Attachment: '附件',//附件
        No_image_available: '暂无图片',//暂无图片
        Submission_Time: '提交时间',//提交时间
        Posting_Time: '入账时间',//入账时间
        Current_Consumption_Amount: '当前消费金额',//当前消费金额
        Current_Refund_Amount: '当前退款金额',//当前退款金额
        Order_Count: '订单数',//订单数
        Date: '日期',//日期
        Last_Statistics_Time: '最后统计时间',//最后统计时间
        Order_Number: '订单号',//订单号
        Tracking_Number: '跟踪号',//跟踪号
        Partition: '分区',//分区
        Fee: '费用',//费用
        Creation_Time: '创建时间',//创建时间
        Deduction_ID: '扣费ID',//扣费ID
        Deduction_Amount: '扣费金额',//扣费金额
        Application_Records: '申请记录',//申请记录
        Application_Amount: '申请金额',//申请金额
        Available: '可用',//可用
        Expired: '过期',//过期
        Application_Time: '申请时间',//申请时间
        Expiration_Time: '过期时间',//过期时间
        Posted: '入账',//入账
        Deducted: '扣费',//扣费
        Consumed: '消费',//消费
        Refunded: '退款',//退款
        Freezing: '冻结中',//冻结中
        consumption_amounts_from: '即将从头再统计每个月的消费金额并写入数据库, 是否继续?',//即将从头再统计每个月的消费金额并写入数据库, 是否继续?
        Selected_dates_update_note: '请先勾选需要更新的日期，只会重新统计所选日期的消费记录。',
        Select_date_records_first: '请先勾选需要更新的日期记录',
        Update_selected_dates_confirm: '将重新统计已勾选日期的消费记录，是否继续?',
        Notification: '提示',//提示
        Confirm: '确定',//确定
        Cancel: '取消',//取消
        Statistics_Failed: '统计失败',//统计失败
        Statistics_Succeeded: '更新成功',
        Total_Amount: '总金额',//总金额
        Export_Order_Details: '导出订单明细',//导出订单明细
        Export_order_details_select_tip: '请先勾选需要导出的消费日期记录',//请先勾选需要导出的消费日期记录
        Export_order_details_loading: '正在导出，请稍候...',//正在导出，请稍候...
        Export_refund_details_select_tip: '请先勾选需要导出的退款日期记录',//请先勾选需要导出的退款日期记录
    },
    // 财务流水  在线充值caiwupup
    caiwupup: {
        Title: '我是标题',//我是标题
        Recharge_Account: '充值账户:',//充值账户:
        Estimated_Amount: '预报金额:',//预报金额:
        Please_Enter_Amount: '请输入金额',//请输入金额
        Recharge_Screenshot: '充值截图:',//充值截图:
        Upload_Screenshot: '上传截图',//上传截图
        File: '个文件',//个文件
        Remarks: '备注信息:',//备注信息:
        Please_Enter_Content: '请输入内容',//请输入内容
        Recharge_Now: '立即充值:',//立即充值:
        Confirm_Submission: '确定提交',//确定提交
        Clear_Content: '清空内容',//清空内容
        Please_contact_freight_forwarder: '请联系货代先在后台添加 收款方式',//请联系货代先在后台添加 收款方式
        Please_Select_Currency: '请选择充值币种',//请选择充值币种
        Please_Select_Payment_Method: '请选择支付方式',//请选择支付方式
        Please_Fill_in_Amount: '请填写金额',//请填写金额
    },
    // 财务流水 导出出库记录
    addwj: {
        Export_Selected_Fields: '导出选择字段',//导出选择字段
        Cancel: '取 消',//取 消
        Confirm: '确 定',//确 定
        Please_select_at_least_four_fields: '请选择四个以上的字段',//请选择四个以上的字段
        Export_succeeded: '导出成功',//导出成功
        Export_failed: '导出失败',//导出失败
    },
    // 财务流水  大货账单
    dhzdlist: {
        Print_Bill: '打印账单',//打印账单
        Bill_ID: '账单ID',//账单ID
        Customer_Balance: '客户余额',//客户余额
        Category: '类别',//类别
        Billing_Cycle: '周期',//周期
        Account_Amount: '账户金额',//账户金额
        Due_Date: '到期时间',//到期时间
        Due_Limit: '到期限制',//到期限制
        Status: '状态',//状态
        Please_check_the_bills_to_print: '请勾选要打印的账单',//请勾选要打印的账单
    },
    // 大货账单 打印
    zdpdf: {
        Bill_Number: '账单编号',//账单编号
        Batch_Print: '批量打印',//批量打印
        Basic_Bil: '基础账单',//基础账单
        Detailed_Bill: '完整账单(包含订单列表)',//完整账单(包含订单列表)
        OK: '确 定',//确 定
        Cancel: '取 消',//取 消
        File_read_error: '文件读取错误。',//文件读取错误。
        API_error: '接口错误,请联系管理员',//接口错误,请联系管理员
    },

    // 小包账单
    xbaozdlist: {
        Print_Bill: '打印账单',//打印账单
        Bill_ID: '账单ID',//账单ID
        Customer_Balance: '客户余额',//客户余额
        Category: '类别',//类别
        Billing_Cycle: '周期',//周期
        Account_Amount: '账户金额',//账户金额
        Due_Date: '到期时间',//到期时间
        Due_Limit: '到期限制',//到期限制
        Status: '状态',//状态
        Please_check_the_bills_to_print: '请勾选要打印的账单',//请勾选要打印的账单
    },
    // 平台账号  添加sku
    openSkuList: {
        Configure_SKU_Grouping: '配置SKU分组',//配置SKU分组
        Batch_Import: '批量导入',//批量导入
        Name: '名称',//名称
        Actions: '操作',//操作
        Delete: '删除',//删除
        ConfirmC: '确认(Ctrl+S)',//确认(Ctrl+S)
        Cancel: '取消',//取消
        Import_SKU_Grouping: '导入SKU分组',//导入SKU分组
        Download_Template: '下载模板',//下载模板
        Download: '下载',//下载
        Group_Name: '分组名称',//分组名称
        Please_enter_remote_area_name: '请输入偏远地区名称',//请输入偏远地区名称
        Import_Data: '导入数据',//导入数据
        Drag_file_here_or: '将文件拖到此处，或',//将文件拖到此处，或
        Click_to_upload: '点击上传',//点击上传
        Upload_EXCEL: '上传EXCEL',//上传EXCEL
        Configure_SKU_Grouping_Details: '配置SKU分组详情列表',//配置SKU分组详情列表
        Please_enter_SKU_name: '请输入sku名称',//请输入sku名称
        Length: '长',//长
        Width: '宽',//宽
        Height: '高',//高
        Weight: '重量',//重量
        This_will_permanently_delete: '此操作将永久删除该sku分组,是否继续?',//此操作将永久删除该sku分组,是否继续?
        Notification: '提示',//提示
        Confirm: '确定',//确定
        Cancel: '取消',//取消
    },
    //财务 消费 双击详情
    xiaofei: {
        Related_orders: '相关订单',//相关订单
        Export: '导出',//导出
        Order_ID: '订单ID',//订单ID
        Channel_name: '渠道名',//渠道名
        Order_Number: '订单号',//订单号
        Tracking_Number: '跟踪号',//跟踪号
        Batch_search_placeholder: '支持批量精确搜索，每行输入一个号码',//支持批量精确搜索，每行输入一个号码
        Search: '搜索',//搜索
        Reset: '重置',//重置
        Consumption_amount: '消费金额',//消费金额
        Consumption_time: '消费时间',//消费时间
    },
    //财务 退款 双击详情
    orders: {
        Related_orders: '相关订单',//相关订单
        Export: '导出',//导出
        Order_ID: '订单ID',//订单ID
        Channel_name: '渠道名',//渠道名
        Order_Number: '订单号',//订单号
        trace_Number: '跟踪号',//跟踪号
        Refund_amount: '退款金额',//退款金额
        Refund_time: '退款时间',//退款时间
        Tracking_number: '运单号',//运单号
    },
    // 财务 消费 海外仓  双击详情
    haiwaiRkdetile: {
        Information_on_warehousing: '入库费信息',//入库费信息
        Warehousing_Fee_Information: '仓储费信息',//仓储费信息
        Export: '导出',//导出
        Warehouse_Name: '仓库名称',//仓库名称
        Volume: '体积',//体积
        Product_Name: '产品名称',//产品名称
        Inbound_Quantity: '入库数量',//入库数量
        Quantity_in_Warehousing: '仓储数量',//仓储数量
        Single_Inbound_Fee: '单件入库费',//单件入库费
        Warehousing_Fee_per_Unit: '单件仓储费',//单件仓储费
        Current_Rental_Cycle_Start_Time: '入库本次收租周期时间',//入库本次收租周期时间
        Total_Cost_of_Warehousing: '入库总费用',//入库总费用
        Total_Warehousing_Cost: '仓储总费用',//仓储总费用
    }


}
